"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SVGTextStyle = _interopRequireDefault(require("./SVGTextStyle"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  font-family: 'spacesword' !important;\n  font-feature-settings: 'liga';\n  font-size: 110%;\n  font-variant: normal;\n  font-weight: normal !important;\n  letter-spacing: 0;\n  text-transform: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _default = (0, _styledComponents.default)(_SVGTextStyle.default).withConfig({
  displayName: "SVGTextIconStyle",
  componentId: "sc-1qzh7ji-0"
})(_templateObject());

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2401/js/UIAvatarDisplay/baseStyledComponents/SVGTextIconStyle.js
// module id = 422
// module chunks = 209 210 211 212